import React from "react";

/**
 * 5-dot brutalist size strip.
 *  - Renders the standard XS / S / M / L / XL band (or a custom `sizes` prop) as five small dots/pills.
 *  - Highlights the recommended size in lime; matched sizes in cyan; the rest stay outlined.
 *  - Shoe-size carousel uses pill-form with the numeric label, otherwise plain dots with letter on hover.
 */
const DEFAULT_LETTERS = ["XS", "S", "M", "L", "XL"];

export const SizeStrip = ({
    recommended,
    matched = [],
    sizes,
    className = "",
    testid,
}) => {
    const labels = sizes && sizes.length ? sizes : DEFAULT_LETTERS;
    const matchedSet = new Set((matched || []).map(String));
    const isShoes = labels.some((l) => /^\d/.test(String(l)));

    return (
        <div
            data-testid={testid}
            className={`flex items-center gap-1.5 ${className}`}
            aria-label={recommended ? `Recommended size: ${recommended}` : "Recommended size"}
        >
            {labels.map((label) => {
                const isRec = String(recommended) === String(label);
                const isMatch = matchedSet.has(String(label));
                const base = isShoes
                    ? "min-w-[28px] h-6 px-1.5 border-2 inline-flex items-center justify-center"
                    : "w-6 h-6 border-2 inline-flex items-center justify-center";
                let palette;
                if (isRec) palette = "bg-[#CCFF00] border-black text-black";
                else if (isMatch) palette = "bg-[#00FFFF] border-black text-black";
                else palette = "bg-white border-black/40 text-black/40";
                return (
                    <span
                        key={String(label)}
                        className={`${base} ${palette} font-mono text-[10px] font-bold uppercase tracking-tight`}
                        title={isRec ? "Your size" : isMatch ? "Available in your fit" : `Also stocked: ${label}`}
                        data-testid={testid ? `${testid}-${label}` : undefined}
                    >
                        {label}
                    </span>
                );
            })}
        </div>
    );
};
